import AsyncStorage from '@react-native-async-storage/async-storage';
import apiClient from './api-client';

// DELETE users/<userId> (Bruno: user/DeleteUser). userId is the app's user id
// (e.g. "POM24642"), the same one get-profile takes. apiClient adds the
// user's Bearer token.

// Removes what this app keeps on the phone for the user (the copy of the
// onboarding answers). The login data itself is cleared by logoutUser(),
// which the screen dispatches right after this succeeds.
const clearLocalUserData = async userId => {
  try {
    await AsyncStorage.removeItem(`onboardingAnswers_${userId}`);
  } catch (e) {}
};

// Permanently deletes the logged-in user's account on the server.
// Throws if the server does not confirm, so the caller can keep the user
// logged in and show the error. Local data is only cleared after the server
// confirms.
export const deleteAccount = async () => {
  let userId;
  try {
    userId = JSON.parse(await AsyncStorage.getItem('Data'))?.userId;
  } catch (e) {}
  if (!userId) {
    throw new Error('Could not find your account. Please log in again.');
  }

  try {
    const res = await apiClient.delete(`users/${encodeURIComponent(userId)}`);
    // Some endpoints answer HTTP 200 but put a failure flag in the body.
    const d = res.data;
    if (d?.status === false || d?.success === false || d?.Success === false) {
      throw new Error(d?.message || d?.Message || 'The server did not delete the account');
    }
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.Message ||
        error.message ||
        'Failed to delete account',
    );
  }

  await clearLocalUserData(userId);
  return true;
};
